const incomeValues = [
  {
    id: '1',
    text: '政府补贴'
  },
  {
    id: '2',
    text: '其他'
  }
]

const backfillValues = [
  {
    label: '需要人力审批',
    value: 'stock'
  },
  {
    label: '需要财务审批',
    value: 'salary'
  },
  {
    label: '需要GR审批',
    value: 'GR'
  },
  {
    label: '证券信息披漏审批',
    value: 'bond'
  },
  {
    label: '证券基金管理审批组',
    value: 'manager'
  },
  {
    label: '需要CEO审批',
    value: 'CEO'
  },
  {
    label: '政企交付审批',
    value: 'deliver'
  },
  {
    label: '政企销管审批',
    value: 'sale'
  },
]

const whetherOptions1 = [
  {
    label: '是',
    value: '1'
  },
  {
    label: '否',
    value: '0'
  }
]

const whetherOptions = [
  {
    text: '参加',
    label: '是',
    value: '1'
  },
  {
    text: '不参加',
    label: '否',
    value: '0'
  }
]
// 投资事项申请单
const investOptions = [
  {
    label: '需周总审批事项',
    value: '2'
  },
  {
    label: '是',
    value: '1'
  },
  {
    label: '否',
    value: '0'
  }
]
const vpOptions = [
  {
    label: '是',
    value: '是'
  },
  {
    label: '否',
    value: '否'
  }
]
const expOptions = [
  {
    label: '引入商标/品牌',
    value: '101'
  },
  {
    label: '引入商版权',
    value: '102'
  },
  {
    label: '引入专利/技术',
    value: '103'
  },
  {
    label: '租赁房屋',
    value: '104'
  },
  {
    label: '购买房屋/土地',
    value: '105'
  },
  {
    label: '采购资产',
    value: '106'
  },
  {
    label: '采购/租赁OPS带宽',
    value: '107'
  },
  {
    label: '引入人员外包',
    value: '108'
  },
  {
    label: '引入技术服务',
    value: '109'
  },
  {
    label: '市场活动',
    value: '110'
  },
  {
    label: '渠道推广',
    value: '111'
  },
  {
    label: '其他',
    value: '112'
  }
]
const incomeOptions = [
  {
    label: '输出商标/品牌',
    value: '201'
  },
  {
    label: '输出版权',
    value: '202'
  },
  {
    label: '输出专利/技术',
    value: '203'
  },
  {
    label: '出租房屋',
    value: '204'
  },
  {
    label: '出售房屋/土地',
    value: '205'
  },
  {
    label: '出售资产',
    value: '206'
  },
  {
    label: '出售/出租OPS带宽',
    value: '207'
  },
  {
    label: '输出安全服务/产品',
    value: '208'
  },
  {
    label: '输出技术服务',
    value: '209'
  },
  {
    label: '推广收入(费商业化)',
    value: '210'
  },
  {
    label: '政府补贴项目',
    value: '211'
  },
  {
    label: '其他',
    value: '212'
  }
]
const freeOptions = [
  {
    label: '战略合作',
    value: '301'
  },
  {
    label: '政府项目',
    value: '302'
  },
  {
    label: '引入商标/品牌',
    value: '303'
  },
  {
    label: '引入版权',
    value: '304'
  },
  {
    label: '引入专利/技术',
    value: '305'
  },
  {
    label: '输出商标/品牌',
    value: '306'
  },
  {
    label: '输出版权',
    value: '307'
  },
  {
    label: '输出专利/技术',
    value: '308'
  },
  {
    label: '其他',
    value: '309'
  }
]

const  selectJuryOptions = [
  {id: '1',value: '1', text: 'S'},
  {id: '2', value: '2',text: 'A'},
  {id: '3', value: '3',text: 'B'},
  {id: '4', value: '4',text: 'C'},
  {id: '5', value: '5',text: 'D'},
]

// 美国管控物质
//硬件
const usaControlsItems = [
  {id: 'ctl_a', value: 'ctl_a', label: '原产于美国境内出口至中国'},
  {id: 'ctl_b',value: 'ctl_b', label: '从美国过境出口至中国'},
  {id: 'ctl_c',value: 'ctl_c', label: '包含美国物料或与美国原产软件捆绑在一起的非美国原厂制造商品，且美国成分超过25%，而出口至中国'},
  {id: 'ctl_d',value: 'ctl_d', label: '非美国制造但属于美国原产技术或软件的直接产品，而出口至中国'},
  {id: 'ctl_e',value: 'ctl_e', label: '由位于美国境外的设备或设备主要组成部分生产的某些物料;该设备或主要组件为美国原产技术或软件的直接产品，进而将该物料出口至中国'},
  {id: 'ctl_f',value: 'ctl_f', label: '物料涉及到加密、航天器或者弹药'},
  {id: 'NO',value: 'NO', label: '以上选项皆不选'},
]

// 软件
const sUsaControlsItems = [
  {id: 'ctl_a',value: 's_ctl_a', label: '原产于美国境内出口至中国'},
  {id: 'ctl_b',value: 's_ctl_b', label: '从美国过境出口至中国'},
  {id: 'ctl_c',value: 's_ctl_c', label: '包含美国受控软件或技术混合的非美国制造软件或技术，且美国成分超过25%，而出口至中国'},
  {d: 'ctl_d',value: 's_ctl_d', label: '非美国制造但属于美国原产技术或软件的直接产品（包括流程与服务），而出口至中国'},
  {id: 'ctl_f',value: 's_ctl_f', label: '物料涉及加密'},
  {id: 'NO',value: 'NO', label: '以上选项皆不选'}
]

// 管控类型
const controlTypeOptions = [
  {id: 'CCL',value: 'CCL', text: '商品管制清单[CCL]'},
  {id: 'EAR99',value: 'EAR99', text: '属于EAR99管制'},
  {id: 'EAR',value: 'EAR', text: '不受EAR管制'},
  {id: 'NOCONTROL',value: 'NOCONTROL', text: '无法确定是否受控'},
]
// 合规要求
const usaRequireOptions = [
  {id: 'LICENSING',value: 'LICENSING', text : '要求供应商获取出口许可证'},
  {id: 'BIS',value: 'BIS', text : '履行通知BIS义务'},
  {id: 'NO', value: 'NO',text : '无需进一步合规要求'},
  
]

// 美国直接产品判断
const productAmericanOptions = [
  {id: 'direct_a', value: 'direct_a', text: '该产品或服务属于美国原产技术或软件的直接产品(包括流程与服务)'},
  {id: 'direct_b', value: 'direct_b', text: '生产该产品或服务使用的设备或主要组件为美国原产技术或软件的直接产品'},
  {id: 'NO', value: 'NO', text: '以上选项皆不选'},
]


function getValueByKey(value, optionsList, mutiple){
  if(!value || !optionsList || !optionsList.length) return value;
  if(!mutiple){
    let vItem = optionsList.find(ii => ii.value == value);
    if(vItem) {
      return vItem.label || vItem.text
    } else {
      return value;
    }
  } else if(typeof value == 'string'){
    let result = [];
    value = value.split(',');
    value.forEach(val => {
      let vItem = optionsList.find(ii => ii.value == val);
      vItem && result.push(vItem.label || vItem.text) ;
    })
    return result.join(',');
  }
  
}

export {
  getValueByKey,
  investOptions,
  incomeValues,
  backfillValues,
  whetherOptions,
  whetherOptions1,
  vpOptions,
  expOptions,
  incomeOptions,
  freeOptions,
  selectJuryOptions,
  usaControlsItems,
  sUsaControlsItems,
  controlTypeOptions,
  usaRequireOptions,
  productAmericanOptions
}
